<template>
  <div class="pl" dir="rtl">
    <div class="pl__card">
      <div class="pl__brand">
        <img v-if="logo" :src="logo" :alt="name || 'logo'" class="pl__logo" @error="logo = ''">
        <div v-else class="pl__logo pl__logo--ph">{{ (name || 'S').charAt(0) }}</div>
        <h1 class="pl__title">ورود به پنل مدیریت</h1>
        <p class="pl__sub">{{ name || 'ساختینئو' }}</p>
      </div>

      <form class="pl__form" novalidate @submit.prevent="login">
        <div v-if="error" class="pl__alert" role="alert">
          <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2"/><path d="M12 7v6M12 16.5v.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          <span>{{ error }}</span>
        </div>

        <label class="pl__label" for="pl-user">نام کاربری</label>
        <div class="pl__field" :class="{ 'is-invalid': touched && !user.trim() }">
          <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><circle cx="12" cy="8" r="4" fill="none" stroke="currentColor" stroke-width="2"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6" fill="none" stroke="currentColor" stroke-width="2"/></svg>
          <input id="pl-user" ref="user" v-model="user" type="text" autocomplete="username" dir="ltr" placeholder="username" :disabled="loading" @input="error = ''">
        </div>
        <small v-if="touched && !user.trim()" class="pl__err">نام کاربری را وارد کنید</small>

        <label class="pl__label" for="pl-pass">رمز عبور</label>
        <div class="pl__field" :class="{ 'is-invalid': touched && !pass }">
          <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2" fill="none" stroke="currentColor" stroke-width="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3" fill="none" stroke="currentColor" stroke-width="2"/></svg>
          <input id="pl-pass" v-model="pass" :type="showPass ? 'text' : 'password'" autocomplete="current-password" dir="ltr" placeholder="••••••••" :disabled="loading" @input="error = ''" @keyup="capsCheck" @keydown="capsCheck">
          <button type="button" class="pl__eye" :aria-label="showPass ? 'پنهان کردن رمز' : 'نمایش رمز'" :title="showPass ? 'پنهان کردن رمز' : 'نمایش رمز'" @click="showPass = !showPass">
            <svg v-if="!showPass" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="2"/></svg>
            <svg v-else viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M3 3l18 18M10.6 6.1A10 10 0 0 1 12 6c6 0 10 6 10 6a17 17 0 0 1-3.2 3.8M6.6 6.6C3.9 8.3 2 12 2 12s4 7 10 7c1.6 0 3-.4 4.3-1" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </button>
        </div>
        <small v-if="touched && !pass" class="pl__err">رمز عبور را وارد کنید</small>
        <small v-else-if="caps" class="pl__warn">Caps Lock روشن است</small>

        <button type="submit" class="pl__btn" :disabled="loading" :aria-busy="loading ? 'true' : 'false'">
          <span v-if="loading" class="pl__spin" aria-hidden="true"></span>
          {{ loading ? 'در حال ورود…' : 'ورود' }}
        </button>

        <button type="button" class="pl__link" @click="forgot = !forgot">رمز عبور را فراموش کرده‌اید؟</button>
        <p v-if="forgot" class="pl__hint">برای بازیابی رمز عبور با مدیر سیستم تماس بگیرید. [بازیابی خودکار رمز: هنوز پیاده‌سازی نشده]</p>
      </form>
    </div>
    <p class="pl__foot">© {{ year }} {{ name || 'ساختینئو' }}</p>
  </div>
</template>

<script>
import axios from "@/api/http";
export default {
  name: 'Login',
  data() {
    return {
      user: '',
      pass: '',
      showPass: false,
      loading: false,
      touched: false,
      error: '',
      caps: false,
      forgot: false,
      logo: localStorage.getItem('logo_url') || '',
      name: '',
      year: new Date().toLocaleDateString('fa-IR', { year: 'numeric' }),
    }
  },
  mounted() {
    this.get_market_config()
    this.$nextTick(() => this.$refs.user && this.$refs.user.focus())
  },
  methods: {
    capsCheck(e) {
      this.caps = !!(e && e.getModifierState && e.getModifierState('CapsLock'))
    },
    login() {
      if (this.loading) return // no double submit
      this.touched = true
      this.error = ''
      if (!this.user.trim() || !this.pass) return
      this.loading = true
      const formData = new FormData()
      formData.append('user', this.user.trim())
      formData.append('pass', this.pass)
      axios.post('/api/admin/user/login', formData, { show_pros: false }).then((res) => {
        const d = res.data || {}
        if (d.error == 1 || !d.token) {
          this.error = d.msg || 'نام کاربری یا رمز عبور اشتباه است'
          return
        }
        localStorage.setItem('languages', JSON.stringify(d.languages))
        localStorage.setItem('token', d.token)
        localStorage.setItem('site_url', d.site)
        localStorage.setItem('user_name', d.user_name)
        if (this.$store) this.$store.commit('syncThemeForUser')
        const r = this.$route && this.$route.query && this.$route.query.redirect
        this.$router.push({ path: typeof r === 'string' && r.startsWith('/') && !r.startsWith('//') ? r : '/dashboard' })
      }).catch((err) => {
        const s = err && err.response && err.response.status
        if (!err.response) this.error = 'ارتباط با سرور برقرار نشد. اتصال اینترنت را بررسی کنید.'
        else if (s === 429) this.error = 'تعداد تلاش‌ها زیاد است؛ کمی بعد دوباره امتحان کنید.'
        else if (s === 401 || s === 403) this.error = (err.response.data && err.response.data.msg) || 'نام کاربری یا رمز عبور اشتباه است'
        else this.error = (err.response.data && err.response.data.msg) || 'خطای سرور (' + s + '). دوباره تلاش کنید.'
      }).finally(() => { this.loading = false })
    },
    get_market_config() {
      axios.get('/api/market/get_market_config', { show_pros: false }).then((res) => {
        const c = (res.data && res.data.configs) || {}
        if (c.logo) { this.logo = c.logo; localStorage.setItem('logo_url', c.logo) }
        this.name = c.name || ''
      }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.pl { min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 24px 16px;
  background: radial-gradient(1200px 600px at 100% 0, var(--accent-soft, #eff6ff) 0, transparent 60%), #f6f7fb; }
.pl__card { width: 100%; max-width: 400px; background: #fff; border-radius: 16px; box-shadow: 0 10px 40px rgba(15, 23, 42, .08), 0 1px 3px rgba(15, 23, 42, .06); padding: 32px 28px 24px; }
.pl__brand { text-align: center; margin-bottom: 20px; }
.pl__logo { height: 56px; max-width: 160px; object-fit: contain; display: inline-block; }
.pl__logo--ph { width: 56px; border-radius: 14px; background: var(--accent, #2563eb); color: #fff; font-size: 26px; font-weight: 800; line-height: 56px; }
.pl__title { font-size: 18px; font-weight: 800; color: #111827; margin: 14px 0 4px; }
.pl__sub { font-size: 13px; color: #6b7280; margin: 0; }
.pl__label { display: block; font-size: 13px; font-weight: 600; color: #374151; margin: 14px 0 6px; }
.pl__field { display: flex; align-items: center; gap: 8px; height: 46px; padding: 0 12px; border: 1px solid #d1d5db; border-radius: 10px; background: #fff; color: #9ca3af; transition: border-color .15s, box-shadow .15s; }
.pl__field:focus-within { border-color: var(--accent, #2563eb); box-shadow: 0 0 0 3px var(--accent-ring, rgba(37, 99, 235, .18)); color: var(--accent, #2563eb); }
.pl__field.is-invalid { border-color: #ef4444; }
.pl__field input { flex: 1; min-width: 0; border: 0; outline: 0; background: transparent; font-size: 15px; color: #111827; height: 100%; text-align: left; }
.pl__eye { border: 0; background: transparent; color: #6b7280; padding: 6px; border-radius: 6px; cursor: pointer; display: flex; }
.pl__eye:hover { background: #f3f4f6; }
.pl__err, .pl__warn { display: block; margin-top: 5px; font-size: 12px; color: #dc2626; }
.pl__warn { color: #b45309; }
.pl__alert { display: flex; gap: 8px; align-items: flex-start; padding: 10px 12px; border-radius: 10px; background: #fef2f2; color: #b91c1c; font-size: 13px; line-height: 1.7; border: 1px solid #fecaca; }
.pl__alert svg { flex: 0 0 auto; margin-top: 2px; }
.pl__btn { width: 100%; height: 46px; margin-top: 22px; border: 0; border-radius: 10px; background: var(--accent, #2563eb); color: #fff; font-size: 15px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; transition: filter .15s; }
.pl__btn:hover:not(:disabled) { background: var(--accent-hover, #1d4ed8); }
.pl__btn:focus-visible { outline: 0; box-shadow: 0 0 0 3px var(--accent-ring, rgba(37, 99, 235, .25)); }
.pl__btn:disabled { opacity: .75; cursor: progress; }
.pl__spin { width: 18px; height: 18px; border: 2px solid rgba(255, 255, 255, .45); border-top-color: #fff; border-radius: 50%; animation: plspin .7s linear infinite; }
@keyframes plspin { to { transform: rotate(360deg); } }
.pl__link { display: block; margin: 14px auto 0; border: 0; background: none; color: var(--accent-text, #1d4ed8); font-size: 13px; cursor: pointer; }
.pl__hint { font-size: 12px; color: #6b7280; text-align: center; margin: 8px 0 0; line-height: 1.8; }
.pl__foot { margin-top: 18px; font-size: 12px; color: #9ca3af; }
@media (max-width: 480px) {
  .pl { padding: 0; justify-content: flex-start; background: #fff; }
  .pl__card { max-width: none; min-height: 100vh; border-radius: 0; box-shadow: none; padding: 48px 20px 24px; }
  .pl__foot { display: none; }
}
</style>
